<nz-card class="card" [nzTitle]="cardTitle">
  <nz-skeleton [nzActive]="true" [nzLoading]="loading">
    <nz-card-meta
      [nzTitle]="cardMetaTitle"
      [nzDescription]="cardDescription ?? ''"
      [nzAvatar]="avatarTemplate"
    ></nz-card-meta>
  </nz-skeleton>
</nz-card>

<ng-template #cardTitle>
  <div class="card-title">
    {{ title }}
  </div>
  <a
    *ngIf="item?.sharePointSiteUrl"
    class="card-title"
    target="_blank"
    rel="external"
    [href]="item?.sharePointSiteUrl"
  >
    <i nz-icon nzType="link"></i>
    SharePoint site
  </a>
</ng-template>

<ng-template #cardMetaTitle>
  <p class="card-title">
    <a target="_blank" rel="external" [href]="item?.webUrl">
      {{ item?.name }}
    </a>
  </p>
</ng-template>

<ng-template #avatarTemplate>
  <i *ngIf="item" class="avatar-icon" nz-icon nzType="file-excel" nzTheme="outline"></i>
</ng-template>
